import React from "react";

  const electionCards = ["govdash-votersCard", "govdash-amountCard" ,"govdash-labhartiCard3", "govdash-labhartiCard" ,"govdash-labhartiCard2"]
export default function ElectionCardShimmer() {
  return (
    <div className="govdash-summaryGrid">
      {Array.from({ length: 6 }).map((_, i) => 
      {
          const theme = electionCards[i % 5];
        return(
        <div key={i} className={`govdash-summaryCard ${theme}`}>
          <div className="govdash-cardContent">
            <i className="fas fa-poll" style={{ opacity: 0.3 }}></i>

            <div>
              <p className="govdash-cardLabel">
                <span
                  className="shimmer"
                  style={{
                    width: "120px",
                    height: "14px",
                    display: "inline-block",
                  }}
                ></span>
              </p>

              <span className="govdash-cardValue">
                <span
                  className="shimmer"
                  style={{
                    width: "150px",
                    height: "30px",
                    display: "block",
                  }}
                ></span>
              </span>
            </div>
          </div>

          <div className="govdash-cardBg"></div>
        </div>
      )})}
    </div>
  );
}
